import { render } from "./PreadmissionNotesRow.vue?vue&type=template&id=2c7a6349&ts=true"
import script from "./PreadmissionNotesRow.ts?vue&type=script&lang=ts&external"
export * from "./PreadmissionNotesRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__